
import * as storyblokRuntime$_12VJr_45rMxfAkjufEbEEohV3GAkPlf5DkePGcYtcQwuA from '/var/lib/jenkins/workspace/Master/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$_Kg3YNaIP_45Oo1xeVVO3vdrVmBavA64QimEtznMByBYo from '/var/lib/jenkins/workspace/Master/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "a.storyblok.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$_12VJr_45rMxfAkjufEbEEohV3GAkPlf5DkePGcYtcQwuA, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$_Kg3YNaIP_45Oo1xeVVO3vdrVmBavA64QimEtznMByBYo, defaults: {} }
}
        